module.exports = __webpack_public_path__ + "static/media/MercBClass4.14cd6710.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/monoshift/MercBClass4.mp4
// module id = 149
// module chunks = 0